import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, isRef as _isRef, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-317d3d78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = {
  class: "sticky",
  id: "navbar-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Premio Forlano", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "banner-container" }
const _hoisted_6 = { class: "banner-text" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Il tuo account", -1))
const _hoisted_8 = { class: "dialog-footer" }

import { Utente } from "@/models/Utente";
import { onMounted, ref, reactive } from "vue";
import { FormInstance, FormRules } from "element-plus";
import router from "@/router";
import { findUtenteByLogin } from "@/services/utente.service";
import { UserFilled } from '@element-plus/icons-vue'
import { store } from "@/utils/store";
import { closeSpinner, startSpinner } from "@/utils/utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderComponent',
  setup(__props) {

const loginRuleFormRef = ref<FormInstance>()

let showLoginDialog = ref(false);
let utente = ref<Utente>(new Utente());
let loginMessage = ref<string>();
let isSticky = ref(false);

onMounted(() => {
    let logged = sessionStorage.getItem("loggedUser");
    if (logged) {
        store.loggedUser = JSON.parse(logged);
    }
    window.addEventListener("scroll", () => {
        let navbar = document.getElementById("navbar-container");
        if (navbar) {
            if (window.scrollY > 60) {
                isSticky.value = true;
                navbar.style.backgroundColor = "#001719";
            } else {
                isSticky.value = false;
                navbar.style.backgroundColor = "transparent";
            }
        }
    });
})

function openLoginDialog() {
    loginMessage.value = '';
    showLoginDialog.value = true;
    loginRuleFormRef.value?.resetFields();
}

async function login() {
    if (loginRuleFormRef.value) {
        await loginRuleFormRef.value.validate(async (valid) => {
            if (valid) {
                try {
                    startSpinner();
                    utente.value.username = utente.value.username?.trim();
                    let res = await findUtenteByLogin(utente.value);
                    setTimeout(() => {
                        if (res?.data) {
                            resetChildPortfolio();
                            sessionStorage.setItem("loggedUser", JSON.stringify(res.data));
                            store.loggedUser = res.data;
                            resetUser();
                            showLoginDialog.value = false;
                        }
                        closeSpinner();
                    }, 500);
                } catch (error: any) {
                    setTimeout(() => {
                        closeSpinner();
                        loginMessage.value = error.response?.data?.message;
                    }, 500);
                }
            }
        })
    }
}

function resetChildPortfolio() {
    sessionStorage.setItem("idChildPortfolio", '');
    sessionStorage.setItem("childPortfolio", "false");
}

function resetUser() {
    utente.value.username = "";
    utente.value.password = "";
}

function logout() {
    store.loggedUser = null;
    sessionStorage.setItem("loggedUser", "");
    router.push('/');
}

// LOGIN FORM VALIDATION

const validateUsername = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        callback(new Error("Campo obbligatorio"));
    }
}

const validatePassword = (rule, value, callback) => {
    if (value) {
        callback();
    } else {
        callback(new Error("Campo obbligatorio"));
    }
}

const ruleForm = reactive({
    username: '',
    password: ''
})

const rules = reactive<FormRules<typeof ruleForm>>({
    username: [{ validator: validateUsername, trigger: "blur" }],
    password: [{ validator: validatePassword, trigger: "blur" }],
})



return (_ctx: any,_cache: any) => {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_menu, {
          "default-active": _unref(store).activeMenu,
          mode: "horizontal",
          "background-color": "transparent",
          "text-color": "#fbfbfb",
          "active-text-color": "#c9a050",
          ellipsis: _unref(store).isMobile,
          "menu-trigger": "hover",
          class: _normalizeClass(_unref(isSticky) ? '' : 'navbar-shadow')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu_item, {
              index: "0",
              style: {"pointer-events":"none","font-weight":"600"}
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, {
              index: "1",
              onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.$router.push('/');})
            }, {
              default: _withCtx(() => [
                _createTextVNode("HOME")
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, {
              index: "2",
              onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.$router.push('/galleria');})
            }, {
              default: _withCtx(() => [
                _createTextVNode("GALLERIA")
              ]),
              _: 1
            }),
            (_unref(store).loggedUser?.ruolo == 'artista_minorenne' || _unref(store).loggedUser?.ruolo == 'artista_maggiorenne')
              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 0,
                  index: "3",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push('/portfolio')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("PORTFOLIO")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_unref(store).loggedUser?.ruolo == 'amministratore' || _unref(store).loggedUser?.ruolo == 'super_amministratore')
              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 1,
                  index: "4",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$router.push('/gestione-utenti');})
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("GESTIONE UTENTI")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_menu_item, {
              index: "5",
              onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$router.push('/contatti');})
            }, {
              default: _withCtx(() => [
                _createTextVNode("CONTATTI")
              ]),
              _: 1
            }),
            _createVNode(_component_el_menu_item, {
              index: "6",
              onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$router.push('/app-android');}),
              style: {"margin-right":"auto"}
            }, {
              default: _withCtx(() => [
                _createTextVNode("SCARICA L'APP")
              ]),
              _: 1
            }),
            (_unref(store).loggedUser)
              ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                  key: 2,
                  index: "7"
                }, {
                  title: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(UserFilled))
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" " + _toDisplayString(_unref(store).loggedUser.username) + " ", 1),
                    (_unref(store).loggedUser.ente)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_4, " / " + _toDisplayString(_unref(store).loggedUser.ente.nome), 1))
                      : _createCommentVNode("", true)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_menu_item, {
                      index: "7-1",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$router.push('/gestione-profilo')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Gestione profilo")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_menu_item, {
                      index: "7-2",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (logout()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Esci")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_unref(store).loggedUser)
              ? (_openBlock(), _createBlock(_component_el_menu_item, {
                  key: 3,
                  index: "8",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (openLoginDialog())),
                  style: {"margin-left":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(UserFilled))
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" Accedi ")
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["default-active", "ellipsis", "class"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(store).pageTitle), 1)
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _unref(showLoginDialog),
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_isRef(showLoginDialog) ? (showLoginDialog).value = $event : showLoginDialog = $event)),
      width: _unref(store).isMobile ? '300' : '500',
      "show-close": false
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_divider, { "content-position": "center" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_button, {
            type: "info",
            plain: "",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_isRef(showLoginDialog) //@ts-ignore
 ? showLoginDialog.value = false : showLoginDialog = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("Annulla")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "info",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (login()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Accedi ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          "label-position": _unref(store).isMobile ? 'top' : 'right',
          "label-width": "auto",
          ref_key: "loginRuleFormRef",
          ref: loginRuleFormRef,
          rules: rules,
          model: _unref(utente)
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { justify: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "Username",
                      class: "pb-2",
                      prop: "username",
                      onInput: _cache[10] || (_cache[10] = ($event: any) => (_isRef(loginMessage) //@ts-ignore
 ? loginMessage.value = '' : loginMessage = ''))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(utente).username,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(utente).username) = $event)),
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "Password",
                      class: "pb-2",
                      prop: "password",
                      onInput: _cache[12] || (_cache[12] = ($event: any) => (_isRef(loginMessage) //@ts-ignore
 ? loginMessage.value = '' : loginMessage = ''))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(utente).password,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(utente).password) = $event)),
                          type: "password",
                          "show-password": "",
                          clearable: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    (_unref(loginMessage))
                      ? (_openBlock(), _createBlock(_component_el_alert, {
                          key: 0,
                          title: _unref(loginMessage),
                          type: "warning",
                          center: "",
                          "show-icon": "",
                          closable: false
                        }, null, 8, ["title"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label-position", "rules", "model"])
      ]),
      _: 1
    }, 8, ["modelValue", "width"])
  ], 64))
}
}

})